"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const uuid_1 = __importDefault(require("uuid"));
const SocketCollectionReference_1 = __importDefault(require("./impl/SocketCollectionReference"));
const NekostoreError_1 = __importDefault(require("../../NekostoreError"));
/**
 * Driver implementation that connects to a remote Nekostore via a socket (e.g. Socket.io).
 */
class SocketDriver {
    constructor(options) {
        this.socket = options.socket;
        this.timeout = options.timeout || 1000;
    }
    collection(id) {
        return new SocketCollectionReference_1.default(this, id);
    }
    request(action, ...args) {
        const requestId = uuid_1.default.v4();
        // console.debug('Request', { action, args, requestId });
        return new Promise((resolve, reject) => {
            const event = `result:${requestId}`;
            const listener = (error, result) => {
                // console.debug('RequestResult', {
                //   action,
                //   args,
                //   requestId,
                //   error,
                //   result,
                // });
                if (error) {
                    return reject(new NekostoreError_1.default(error.code || 'unknown', error.message));
                }
                return resolve(result);
            };
            this.socket.once(event, listener);
            setTimeout(async () => {
                this.socket.off(event, listener);
                reject(new NekostoreError_1.default('timeout', `${action} timed out ${requestId}`));
            }, this.timeout);
            this.socket.emit(`action:${action}`, requestId, ...args);
        });
    }
}
exports.default = SocketDriver;
//# sourceMappingURL=SocketDriver.js.map